import styled from 'styled-components/macro';

export const UnstyledList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;
